import React from 'react';
import { ShxHelpText } from '../common/ShxHelpText.js';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useUserSetting } from '@soulhx/client-store';

export const CommsSettings = () => {
  const { t } = useTranslation(['comms']);
  const { settingValue: showFixed, update: updateShowFixed } = useUserSetting<boolean>('commsShowFixedBugs');
  const { settingValue: showAnnouncementsOnHome, update: updateShowAnnouncementsOnHome } = useUserSetting<boolean>(
    'generalShowAnnouncementsOnHome'
  );

  return (
    <>
      <ShxHelpText pageName="comms" textName="commsSettings" className="mb-4" />

      <ShxHelpText pageName="comms" textName="showFixedBugs" className="mb-0" />
      <Form.Group className="mb-5">
        <Form.Label>{t('comms:settings.showFixed.label')}</Form.Label>

        <Form.Check
          type="switch"
          checked={showFixed}
          label={t('comms:settings.showFixed.text')}
          onChange={() => updateShowFixed(!showFixed)}
        />
      </Form.Group>

      <ShxHelpText pageName="comms" textName="showAnnouncementsOnHome" className="mb-0" />
      <Form.Group className="mb-5">
        <Form.Label>{t('comms:settings.showAnnouncementsOnHome.label')}</Form.Label>

        <Form.Check
          type="switch"
          checked={showAnnouncementsOnHome}
          label={t('comms:settings.showAnnouncementsOnHome.text')}
          onChange={() => updateShowAnnouncementsOnHome(!showAnnouncementsOnHome)}
        />
      </Form.Group>
    </>
  );
};
